"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@dc/ui/components";
import type { Citation } from "../types";
import { CitationPopover } from "./CitationPopover";
interface CitationButtonProps {
  citations: Citation[];
  /** Optional citation ID search parameter name (e.g., 'citationId') */
  citationIdParam?: string;
  /** Optional callback to handle citation click, overrides default navigation behavior */
  onCitationClick?: (citation: Citation) => void;
}

/**
 * Component to render one or more citations with a popover
 */
export const CitationButton = t0 => {
  const $ = _c(7);
  const {
    citations,
    citationIdParam,
    onCitationClick
  } = t0;
  if (citations.length === 0) {
    return null;
  }
  const sourceText = citations.length === 1 ? "1 source" : `${citations.length} sources`;
  let t1;
  if ($[0] !== sourceText) {
    t1 = <Button size="sm" variant="solid" color="default" className="inline-flex h-6 max-h-6 min-h-6 rounded-full bg-default-200 px-2" data-testid="citation"><span className="font-['Inter'] font-normal text-foreground text-xs leading-4">{sourceText}</span></Button>;
    $[0] = sourceText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== citationIdParam || $[3] !== citations || $[4] !== onCitationClick || $[5] !== t1) {
    t2 = <span className="inline-flex align-middle"><CitationPopover citations={citations} citationIdParam={citationIdParam} onCitationClick={onCitationClick} trigger={t1} /></span>;
    $[2] = citationIdParam;
    $[3] = citations;
    $[4] = onCitationClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};